import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  grpBannerImg,
  groupRoleAlerts,
  groupRolePriviledge,
  removePhraseBetweenCommas,
  renderGenderPronoun,
  profilePicValidityCheck,
} from "../../../utils/constants";
import { toolkitCategories } from "../../../utils/categories";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import Select from "react-select";
import InviteMembers from "./InviteMembers";
import AddMember from "../../../components/AddToGroup/AddMember";
import GroupSettings from "./GroupSettings";
import moment from "moment";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import AddToGroupBtn from "../../../components/AddToEvent/AddToGroupBtn";
import { takeRight } from "lodash";
import GroupOwnerSelector from "./GroupOwnerSelector";
import { deepClone } from "../../../utils/copyObject";

class SingleGroupMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      privacy: null,
      currentRole: this.props.currentRole,
      description: "",
      preventCreate: false,
      invitedUsers: [],
      isOpen: false,
      users: [],
      isGroupArchived: false,
      groupArchiveModal: false,
      members: this.props.members,
      group: this.props.group,
      searchedUser: "",
      removeUsers: [],
      showGrpMenu: false,
      groupLength: this.props.group.members.length,
      isSettingsUpdate: this.props.isSettingsUpdate,
      groupOwnerSelectorModal: false,
    };
  }

  componentDidMount() {
    let { pathname } = this.props.location;
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/settings/${this.props.group._id}`;
    if (pathname == url) {
      this.setState({ showGrpMenu: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let { members } = this.props;
    // console.log('this.props----', this.props)
    // console.log('this.prevState---- ', prevState)
    // console.log('prevProps--- ', prevProps)
    if (prevProps.members.length != members.length) {
      this.setState({ groupLength: members.length });
    }

    if (prevProps.isSettingsUpdate != this.props.isSettingsUpdate) {
      this.setState({
        bannerImg: this.props.group.bannerImg,
        name: this.props.group.name,
        privacy: this.props.group.privacy,
        group: {
          ...this.state.group,
          bannerImg: this.props.group.bannerImg,
          name: this.props.group.name,
          privacy: this.props.group.privacy,
          address: this.props.group.address,
          location: this.props.group.location,
        },
      });
    }
  }

  setGroupOwnerSelector = (val) => {
    this.setState({
      groupOwnerSelectorModal: val,
    });
  };

  isGrpSettings = () => {
    let { pathname } = this.props.location;
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/settings/${this.props.group._id}`;
    if (pathname == url) {
      this.setState({ showGrpMenu: true });
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  closeGroupModal = () => {
    this.setState({ isOpen: false });
  };

  checkUrl = () => {
    let { organizationId } = this.props.user.profile;
    let { history } = this.props;
    let { group } = this.state;
    let current =
      history && history.location && history.location.pathname
        ? history.location.pathname
        : "";

    if (group) {
      // console.log(current)
      let url = `/home/groups/${organizationId._id}/view/${group._id}/settings`;

      if (current == url) {
        return true;
      } else {
        return false;
      }
    }
  };

  changeMemberLength = (members) => {
    console.log("grp_meu ---", members);
    this.props.updateGroupMembers(members);
  };

  toGroupList = () => {
    let { organizationId } = this.props.user.profile;
    this.props.history.push(`/home/groups/${organizationId._id}/discover`);
  };

  createGroupEvent = () => {
    const { group } = this.props;
    const result = {
      groupEvent: {
        name: group.name,
        groupId: group._id,
      },
    };

    const mappedCategory = toolkitCategories.filter(
      (e) => e.link == "conferences-events"
    )[0];
    this.props.onProfileUpdate(result);
    // toolkit/:groupId/:category/ad
    this.props.history.push({
      pathname: `/home/toolkit/${group._id}/conferences-events/add`,
      // pathname:`/home/toolkit/conferences-events/events`,
      state: {
        category: mappedCategory.name,
      },
    });
  };

  changeGroupRole = (val) => {
    this.setState({ currentRole: val });
    this.props.changeGroupRole(val);
  };

  incrementMemberCount = (val) => {
    let { memberCount } = this.state;
    memberCount = memberCount + val;
    this.setState({ memberCount });
  };

  grpHomePage = () => {
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/view/${this.state.group._id}`;
    this.props.history.push(url);
  };

  goToMembersPage = () => {
    let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}/members`;
    this.props.history.push(url);
  };

  showArchiveGroupModal = () => {
    this.setState({
      preventCreate: false,
      groupArchiveModal: !this.state.groupArchiveModal,
      isGroupArchived: false,
    });
  };

  handleArchiveGroup = () => {
    this.setState({ preventCreate: true });
    let { group } = this.state;
    let that = this;
    let isArchived = group.isArchived != true ? true : false;
    axios
      .post(url.archiveSingleGroup, {
        groupId: group._id,
        isArchived,
        orgId: group.organizationId,
      })
      .then(({ data }) => {
        let res = data.data;
        delete res.groupOwner;
        console.log("data.data---- ", res);
        that.setState({
          isGroupArchived: true,
          group: { ...group, ...res },
          preventCreate: false,
        });
        that.props.updateGroupSettings(res);
      });
  };

  handleUpdateOwner = (data) => {
    this.props.updateGroupSettings({
      groupOwner: data,
    });
    if (this.props.members && Array.isArray(this.props.members)) {
      const membersOld = deepClone(this.props.members);

      const index = membersOld.findIndex((x) => x.o_id == data._id);
      if (index >= 0) {
        membersOld[index].role = 1;
      }
      if (this.props.updateGroupMembersData) {
        this.props.updateGroupMembersData(membersOld);
      }
    }
  };

  render() {
    let {
      name,
      invitedUsers,
      users,
      preventCreate,
      showGrpMenu,
      isOpen,
      group,
      groupArchiveModal,
      isGroupArchived,
      currentRole,
      groupLength,
      searchedUser,
      groupOwnerSelectorModal,
    } = this.state;
    let { groupOwner, privacy, createdOn } = group;
    let { user } = this.props;
    let isCreate = (name != "") & (privacy != null) ? true : false;
    // console.log('invitedUsers: ', invitedUsers)
    let grp_img =
      group && group.bannerImg && group.bannerImg.url
        ? group.bannerImg.url
        : grpBannerImg;

    const groupOwnerObject = this.props.group
      ? this.props.group.groupOwner
        ? this.props.group.groupOwner
        : {}
      : {};

    return (
      <div className="grp_single_page_menu_container col-md-2 col-lg-2 side-navbar-bg custom_left_menu boxShadow1">
        <div className="sidebar-category-section custom_left_menu_section">
          <div className="sidebar-menuItem custom_left_menu_section_menuItem">
            <img
              src={grp_img}
              className={`grp_single_page_cover_img ${
                group && group.bannerImg && group.bannerImg.url
                  ? ""
                  : "grp_img_border_bottom"
              }`}
            />
          </div>

          {groupOwnerSelectorModal && (
            <GroupOwnerSelector
              user={user}
              open={groupOwnerSelectorModal}
              onClose={() => {
                this.setGroupOwnerSelector(false);
              }}
              group={this.props.group}
              handleUpdateOwner={this.handleUpdateOwner}
            />
          )}

          <span className="grp_single_page_group_name custom_left_section_menu_fields">
            <span
              className={`grp_create_page_group_name active`}
              onClick={() => this.grpHomePage()}
            >
              {group.name}
            </span>
            <span className="grp_create_page_group_status">
              {" "}
              {privacy != null
                ? groupContentFields(privacy)["name"]
                : "Group Status"}
            </span>{" "}
            ·
            <span
              className="grp_create_page_member_count"
              onClick={() => this.goToMembersPage()}
            >
              {" "}
              {groupLength} members
            </span>
            <span className={`grp_create_page_group_status grp_page_fdate`}>
              Started on {moment(createdOn).format("MMM Do, YYYY")}
            </span>
          </span>
          {group && group.address ? (
            <div className="grp_single_page_group_name custom_left_section_menu_fields">
              <span className="grp_create_page_member_count">Address :</span>
              <span className="grp_create_page_group_status grp_page_fdate">
                {removePhraseBetweenCommas(group.address, "CAL Fire")}
              </span>
            </div>
          ) : (
            ""
          )}

          <div className="custom_left_menu_user_container">
            {profilePicValidityCheck(groupOwnerObject.profilePic) ? (
              <img
                className="custom_left_menu_user_profilePic"
                src={groupOwnerObject.profilePic}
              />
            ) : (
              <span data-letters={this.getInitials(groupOwnerObject)}></span>
            )}
            <span className="custom_left_menu_user_details">
              <span className="custom_left_menu_user_name">
                {groupOwnerObject.firstName} {groupOwnerObject.lastName}{" "}
                <span className="user_gender_pronoun_groups">
                  {renderGenderPronoun(groupOwnerObject)}
                </span>
              </span>

              <span className="custom_left_menu_user_role">Group Admin</span>

              {groupRolePriviledge({
                role: this.props.currentRole,
                action: 0,
                group: this.props.group,
                role_priv: [0, 1],
                comparison: null,
                isAdmin: this.props.currentRole == 0,
              }) ? (
                <span
                  className="wp-link-text"
                  onClick={() => {
                    this.setGroupOwnerSelector(true);
                  }}
                >
                  Change admin
                </span>
              ) : (
                ""
              )}
            </span>
          </div>

          {/* {createdBy._id == user.profile._id ? ( */}

          {groupRolePriviledge({
            role: this.props.currentRole,
            action: 0,
            group: this.props.group,
            role_priv: [0, 1],
            comparison: null,
            isAdmin: this.props.currentRole == 0,
          }) ? (
            <span
              className={`custom_left_menu_user_container grp_single_settings_item ${
                this.checkUrl("ST") ? "fw800" : ""
              }`}
              // style={{'fontWeight': this.checkUrl('ST')?'800':'100'}}
              onClick={() => this.props.goToSettings("ST")}
            >
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-return-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5z"/>
          </svg> */}
              Group Settings
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
              </svg>
            </span>
          ) : null}

          {!showGrpMenu &&
          groupRolePriviledge({
            role: currentRole,
            action: 0,
            eventType: "Invite",
            role_priv: group.privacy =="PRIVATE"? [0,1] : [0, 1, 2, 1000],
            group,
          }) ? (
            <div
              className="single_group_menu_invite_members"
              onClick={() => this.setState({ isOpen: true })}
            >
             Add User
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                <path
                  fillRule="evenodd"
                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                />
              </svg>
            </div>
          ) : null}

          {!showGrpMenu &&
          groupRolePriviledge({
            role: currentRole,
            action: 0,
            comparison: null,
            role_priv: [0, 1, 2, 1000],
            isAdmin: currentRole == 0 || currentRole == 1,
            eventType: "create_event",
            group,
          }) ? (
            <div
              className="single_group_menu_invite_members single_grp_menu_event_btn"
              onClick={() => this.createGroupEvent()}
            >
              Create Event{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z" />
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
              </svg>
            </div>
          ) : null}

          {groupRolePriviledge({
            role: currentRole,
            action: 0,
            comparison: "<",
            isAdmin: currentRole == 0 || currentRole == 1,
            group,
          }) ? (
            <Alert
              color="danger"
              className="col-lg-9 col-md-9 groupAlertContainer"
            >
              <span className="alert-info-text">
                {/* <span className="alert-info-icon"></span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  className=""
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                </svg>
                <span>
                  {groupRoleAlerts({
                    role: currentRole,
                    privacy: group.privacy,
                  })}
                  {group.privacy == "ENTERPRISE" ? (
                    <AddToGroupBtn
                      isSingleGrpMenu={true}
                      incrementMemberCount={this.incrementMemberCount}
                      changeGroupRole={this.changeGroupRole}
                      groupType={currentRole == -1 ? 0 : 1}
                      mod_height={"35px"}
                      item={group}
                      currentGroupJoinedAnounymously={
                        this.props.currentGroupJoinedAnounymously
                      }
                      updateDataAfterAnonymousToggle={
                        this.props.updateDataAfterAnonymousToggle
                      }
                    />
                  ) : null}
                </span>
              </span>
            </Alert>
          ) : group &&
            group.isArchived != true &&
            group.groupOwner &&
            group.groupOwner._id != this.props.user.profile._id ? (
            <AddToGroupBtn
              isSingleGrpMenu={true}
              incrementMemberCount={this.incrementMemberCount}
              changeGroupRole={this.changeGroupRole}
              groupType={currentRole == -1 ? 0 : 1}
              mod_height={"35px"}
              item={group}
              currentGroupJoinedAnounymously={
                this.props.currentGroupJoinedAnounymously
              }
              updateDataAfterAnonymousToggle={
                this.props.updateDataAfterAnonymousToggle
              }
            />
          ) : null}

          {(groupOwner &&
            (groupOwner._id == user.profile._id ||
              groupOwner == user.profile._id)) ||
          user.profile.orgAdmin ? (
            <span
              className={`single_group_menu_leave_group single_group_menu_archive_group`}
              onClick={() => this.showArchiveGroupModal()}
            >
              {group.isArchived != true ? "Archive" : "Restore Group"}
              <span className="ml10 flaticon-trash"></span>
            </span>
          ) : null}

          <span className="custom_left_menu_user_container grp_single_settings_item">
            <span
              className="grp_page_menu_item_back_btn"
              onClick={() => this.toGroupList()}
            >
              Back to Groups
            </span>
          </span>

          {!showGrpMenu &&
          groupRolePriviledge({
            role: currentRole,
            action: 0,
            eventType: "Invite",
            role_priv: [0, 1, 2, 1000],
            group,
          }) ? (
            <AddMember
              members={this.props.members}
              closeGroupModal={this.closeGroupModal}
              changeMemberLength={this.changeMemberLength}
              isOpen={isOpen}
              group={group}
            />
          ) : null}

          {/* <InviteMembers group={group} /> */}
        </div>

        <Modal
          isOpen={groupArchiveModal}
          className="single_grp_menu_leave_option dashboardArchiveModalContainer createModalContainer"
        >
          <ModalHeader
            className="dashboardHeader"
            // charCode="X"
            //   toggle={()=>this.closeActionsModal()}
          >
            <div className="dashboardModalTitle">
              {group.isArchived ? "Restore Group" : "Archive Group"}
              <div>"{group.name}"?</div>
            </div>
          </ModalHeader>
          <ModalBody className="dashboardModalBody archiveDashboardModalContent">
            {isGroupArchived ? (
              <span>
                You have {group.isArchived ? "archived" : "restored"} this
                group.
              </span>
            ) : (
              <span>
                You're about to {group.isArchived ? "restore" : "archive"} this
                group.
                {group.isArchived
                  ? " Do you wish to continue?"
                  : "Once a group is archived, only you will be able to access it, but you will not be able to engage with it."}
              </span>
            )}

            <span>
              <div
                className="submitPrivacyContainer archiveBtnContainer"
                style={{ padding: "10px 0px 0px 0px" }}
              >
                {isGroupArchived != true ? (
                  <Button
                    className={`archiveDashboardModalBtn ${
                      preventCreate ? "disabledBtn" : ""
                    }`}
                    onClick={() => this.handleArchiveGroup({ value: 3 })}
                  >
                    <span className="">
                      {group.isArchived != true ? "Archive" : "Restore Group"}
                      <span className="ml10 flaticon-trash"></span>
                    </span>
                  </Button>
                ) : null}

                <Button
                  outline
                  color="secondary"
                  className="cancelDashboardModalBtn"
                  onClick={() => this.setState({ groupArchiveModal: false })}
                >
                  <span className="">Close</span>
                </Button>
              </div>
            </span>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(SingleGroupMenu, axios)));
